var _path, _path2, _path3, _path4, _path5, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistrainmentDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M18.567 10.407v-2.27a3.588 3.588 0 013.588-3.588h13.358a3.588 3.588 0 013.588 3.588v10.729a3.588 3.588 0 01-3.588 3.588h-6.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M38.213 8.3l-9.296 4.99-9.696-5.391"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.217 18.809c.021-.776.021-2.771-1.552-3.866-1.365-.95-3.222-1.183-4.51-.043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.064 12.522l-2.004-2.02-.889 2.703-2.751.726 1.897 2.121-.747 2.745 2.785-.582 2.004 2.019.889-2.702 2.75-.726-1.896-2.121.747-2.745-2.785.582z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.032 20.234h4.412"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 18.238,
    cy: 30.502,
    r: 8.229
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15.189,
    cy: 28.535,
    r: 1.445
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrainmentDeposit);
export default __webpack_public_path__ + "static/media/distrainmentDeposit.55ef2662a5bef0cb999912674812f6e0.svg";
export { ForwardRef as ReactComponent };